import apiConfig from '../../../../../../../config/api'
import { apiRequestorHelper } from '../../../../../../../helpers'

export const getMonitoringSourceService = ({dateValue}) => {
    return apiRequestorHelper({
        url: apiConfig.url + '/transaction/inside/getMonitoringSourcesSumary',
        method: 'post',
        body: {
            dateRange: dateValue
        }
    })
}